import Vue from 'vue';
import VueX from 'vuex';
import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';
import user from './modules/user/user';
import intercom from './modules/intercom';

const logrocketPlugin = createPlugin(LogRocket, (mutation) => {
  if (mutation.type === 'guest/guestEdit/SET_GUEST_DETAILS') { // TODO: Check and update filter
    return {
      ...mutation,
      firstName: undefined,
      lastName: undefined,
      email: undefined,
      notes: undefined,
      phone: undefined,
      company: undefined,
      photoURL: undefined,
    };
  }
  if (mutation.type === 'guest/guestImport/SET_GUESTS_TO_IMPORT') {
    return null;
  }
  if (mutation.type === 'guest/guestImport/SET_IMPORT_FILE_DATA') {
    return null;
  }

  return mutation;
});

Vue.use(VueX);

const store = new VueX.Store({
  strict: process.env.VUE_APP_MODE === 'development' || process.env.NODE_ENV === 'development',
  modules: {
    user,
    intercom,
  },
  plugins: [logrocketPlugin],
});

export default store;
